module.exports = __webpack_public_path__ + "static/media/Page23.2fdd8e2a.png";